import "bootstrap";
import "channels";
import "controllers";

import { DeleteEE } from "../components/dashboard_EE";
import {
  autocompleteSearchEe,
  autocompleteSearchPp,
  autocompleteSearchPpArchives,
} from "../components/autocomplete";
import addIntervenants from "../components/add_intervenants";
import modeOperatoire from "../components/mode_operatoire";
import signatureIntervenants from "../components/signature_intervenants";
import documentUpload from "../components/document_upload";
import { disableSearchButton } from "../components/search_button";
import { enableSearchButton } from "../components/search_button";
import { showReadMoreText } from "../components/show_hidden_sections";
import { showArchivesFilter } from "../components/archives_filter";
import { openTabValides } from "../components/archives_filter";
import { openTabArchives } from "../components/archives_filter";
import { openDefaultTab } from "../components/archives_filter";
import { newSession } from "../components/session_new";
import searchableSelects from "../components/searchable_select";
import signaturePad from "../plugins/signature_pad";
import { disableScrollOnAdminPps } from "../components/disable_scroll";
import { disableScrollOnWorkPermitSignatures } from "../components/disable_scroll";
import { enableSubmitIfCheckboxChecked } from "../components/enable_submit_on_checked";
import { sendAlertWhenInvalid } from "../components/enable_submit_on_checked";

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"

require("jquery")
require("@nathanvda/cocoon")

Rails.start()
ActiveStorage.start()

DeleteEE();
autocompleteSearchEe();
autocompleteSearchPp();
autocompleteSearchPpArchives();
addIntervenants();
documentUpload();
disableSearchButton();
enableSearchButton();
showReadMoreText();
showArchivesFilter();
openTabValides();
openTabArchives();
openDefaultTab();
newSession();
signaturePad();
disableScrollOnAdminPps();
disableScrollOnWorkPermitSignatures();
enableSubmitIfCheckboxChecked();
sendAlertWhenInvalid();

document.addEventListener("DOMContentLoaded", () => {
  modeOperatoire();
  signatureIntervenants();
});

// Upgrades every long <select> on the page — and any inserted later — into a
// searchable one. Guarded for both load orders: the pack runs at the end of
// <body>, but a deferred build would land after DOMContentLoaded.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", searchableSelects);
} else {
  searchableSelects();
}
